/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DateObject } from 'react-multi-date-picker';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import jmoment from 'moment-jalaali';
import weekends from 'react-multi-date-picker/plugins/highlight_weekends';
import 'react-multi-date-picker/styles/colors/teal.css';
import {
  mapCalendarToCalendars,
  mapCalendarToLocales,
  mapCalendarToWeekDays,
  mapCalendarToFormats,
  magicNumbers,
  mapLanguageToCalendar,
  getEnv,
} from 'utils';
import { isFunction } from 'lib';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import UiButton from 'ui-components/ui-button/UiButton';
import AnalogTimePicker from 'react-multi-date-picker/plugins/analog_time_picker';
import {
  StyledJalaliDatePicker,
  StyledUiDatePicker,
} from './JalaliDatePicker.styles';

const Footer = ({ setValue }) => {
  const { t } = useTranslation();
  return (
    <div className='flex end p-10 rtl center'>
      <UiButton variant='text' onClick={() => setValue(new DateObject())}>
        {t('common:today')}
      </UiButton>
    </div>
  );
};

const JalaliDatePicker = ({
  name,
  control,
  onChange,
  date,
  selectedCalendar = mapLanguageToCalendar[getEnv('REACT_APP_LANGUAGE')],
  portal,
  hasTimePicker = false,
  hasFooter = false,
  allowedPastDaysCount,
  ...props
}) => {
  const [value, setValue] = useState(
    date ? new DateObject(date) : new DateObject()
  );
  const datePickerRef = useRef(null);

  /**
   * بعد از تغییر تاریخ به کامپوننت والد خبر میدهد
   */
  useEffect(() => {
    if (isFunction(onChange)) {
      onChange(
        new DateObject(value)
          .convert(gregorian, gregorian_en)
          .format(hasTimePicker ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, hasTimePicker, onChange]);

  return (
    <StyledJalaliDatePicker
      className='jalali-date-picker flex'
      data-testid={props?.['data-testid']}
    >
      <span className='date-time flex'>
        <StyledUiDatePicker
          name={name}
          control={control}
          portal={portal}
          inputClass='input'
          editable={false}
          ref={datePickerRef}
          className='teal'
          format={hasTimePicker ? 'HH:mm - YYYY-MM-DD' : 'YYYY-MM-DD'}
          render={(value, openCalendar) => {
            return (
              <div className='flex between date-time-wrapper'>
                <DisplaySelectedDateTime
                  value={value}
                  openCalendar={() => openCalendar()}
                />
                <UiIcon
                  icon='ri-calendar-2-line'
                  className='pr-20'
                  size={20}
                  onClick={() => openCalendar()}
                />
              </div>
            );
          }}
          calendar={mapCalendarToCalendars[selectedCalendar]}
          locale={mapCalendarToLocales[selectedCalendar]}
          value={value}
          onChange={setValue}
          weekDays={mapCalendarToWeekDays[selectedCalendar]}
          minDate={jmoment()
            .subtract(
              allowedPastDaysCount || magicNumbers.LAST_FORTY_DAYS,
              'days'
            )
            .format(mapCalendarToFormats[selectedCalendar])}
          maxDate={jmoment().format(mapCalendarToFormats[selectedCalendar])}
          plugins={[
            weekends(),
            // eslint-disable-next-line react/jsx-key
            hasTimePicker ? <AnalogTimePicker hideSeconds /> : <></>,
            hasFooter ? (
              <Footer position='bottom' setValue={setValue} />
            ) : (
              <></>
            ),
          ]}
          {...props}
        />
      </span>
    </StyledJalaliDatePicker>
  );
};

JalaliDatePicker.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  date: PropTypes.any,
  portal: PropTypes.bool,
  allowedPastDaysCount: PropTypes.number,
  hasFooter: PropTypes.bool,
  hasTimePicker: PropTypes.bool,
};

export default JalaliDatePicker;

/**
 * کامپوننت مربوط به رندر کردن قسمت مبوط به نمایش بازه زمانی انتخاب شده
 * @returns
 */
const DisplaySelectedDateTime = ({ openCalendar, value }) => {
  return (
    <div className='custom-range-input' onClick={openCalendar}>
      {value && <span>{value}</span>}
    </div>
  );
};
DisplaySelectedDateTime.propTypes = {
  openCalendar: PropTypes.func,
  value: PropTypes.string,
};
